import template from './contact_request.html';
import controller from './contact_request.controller';
import './contact_request.scss';

let branchManagementContactRequestComponent = {
    restrict: "E",
    bindings: {},
    template,
    controller
};

export default branchManagementContactRequestComponent;


// WEBPACK FOOTER //
// ./client/app/components/branch_management/components/contact_request/contact_request.component.js